module.exports = __webpack_public_path__ + "static/media/Agenda4.26db3bab.png";


//////////////////
// WEBPACK FOOTER
// ./src/imagens/Agenda/Agenda4.png
// module id = 1968
// module chunks = 0